import { Card } from '@interfaces/config';
import { CmsComponentTypeEnum } from '@models/enums/cms-component-type.enum';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';

export namespace TestimonialSlider {
  export const TypeEnum = CmsComponentTypeEnum.TESTIMONIAL_SLIDER;

  export interface SlideConfig {
    image?: string;
    headline: string;
    subHeadline?: string;
    solutions: Card.ComponentConfig[];
  }

  export interface ComponentConfig extends BaseComponentConfig {
    slides: SlideConfig[];
  }
}
